import { createApiConstants, createConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'container';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');

export const UPDATE = createConstants(NAMESPACE, 'update')(
  'PAGE_INDEX',
  'SHOULD_CALL_INIT',
);
